import { Button, Card, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import ArchiveAuditCard from "./ArchiveAuditCard";
import { useEffect, useState } from "react";
import LoadingStuck from "../../reuse/LoadingStuck";
import Api, { BaseUrl } from "../../../api/Api";


function generateArrayOfYears(min_year) {
  const max = new Date().getFullYear();
  const min = min_year;
  let years =[];
  for (let i = max; i >= min; i--) {
    years.push(i);
  }
  return years;
}

const option_months=["Январь", "Февраль", "Март", "Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"].map((element,index) => {return{label:element, value:index+1}})
const options_year = generateArrayOfYears(2020).sort((a,b)=>a-b).map((element)=>{return{label:`${element}`,value:element}});

const ArchiveAuditsInterface = ({data}) => {
    const [name,setName]=useState(null);
    const [month_from,setMonthFrom]=useState(null);
    const [month_to,setMonthTo]=useState(null);
    const [year,setYear]=useState(null);

    const [interfaceData,setInterfaceData]=useState(data);
    
    const handleClearFilters = () => {
            setName(null);
            setMonthFrom(null);
            setMonthTo(null);
            setYear(null);
            setInterfaceData(data); // Возвращаем исходный массив
        };

    const handleFilterData = () => {
        const result_filter=data.filter(item => {
            if (name !== null && item.id !== name) return false;
            const itemMonth = Number(item.start_datetime.split("-")[1]);
            // Исправлено: оставляем только те, у которых месяц >= month_from
            if (month_from !== null && itemMonth < month_from) return false;
            // Исправлено: оставляем только те, у которых месяц <= month_to
            if (month_to !== null && itemMonth > month_to) return false;

            if (year !== null && Number(item.start_datetime.split("-")[0])!== year) return false;
            return true;
        });
        setInterfaceData(result_filter);
    }

    useEffect(() => {
        handleFilterData();
    }, [data, name, month_from, month_to, year]);
    
    if(data.length===0){
        return(<p>В системе нет архивных аудитов.</p>)
    }
    
    const options_names=data.map((item)=>({label:item.name, value:item.id})) || [];

    return(
            <>
            <div>
                <h5>Архивные</h5>
                <Card>
                    <Card.Body >
                        <div className="search-filter-archive">
                            <Select 
                            onChange={(e)=>setName(e?.value || null)}
                            // value={name}
                            options={options_names} 
                            placeholder="По названию" 
                            isClearable 
                            className="search-filter-archive-name-audit"/>
                            <Select 
                            onChange={(e)=>setMonthFrom(e?.value || null)}
                            // value={month_from}
                            options={option_months} 
                            placeholder="ОТ" 
                            isClearable 
                            className="search-filter-archive-date"/>
                            <span> - </span>
                            <Select 
                            onChange={(e)=>setMonthTo(e?.value || null)}
                            options={option_months} 
                            // value={month_to}
                            placeholder="ДО" 
                            isClearable 
                            className="search-filter-archive-date"/>
                            <Select 
                            onChange={(e)=>setYear(e?.value || null)}
                            // year={year}
                            options={options_year} 
                            placeholder="Год" 
                            isClearable 
                            className="search-filter-archive-year"/>
                            <div>
                                <Button 
                                onClick={()=>handleClearFilters()}
                                className="m-1" variant="light">Очистить</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                <div>
                    {!interfaceData.length>0 ? <p>Данных нет.</p> : <>
                    <Row>
                    {interfaceData.map((item, index)=>(
                        <Col md={4}>
                        <ArchiveAuditCard key={index} audit={item}/>
                        </Col>
                    ))}
                    </Row>
                    </> }
                    {/* {data.map((item)=>(<p>{JSON.stringify(item)}</p>))} */}
                </div>
            </div>
            </>
        )
}

const ArchiveAuditFetch = () => {
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(false);

    const [errorInfo,setErrorInfo]=useState(null);
    const [data,setData]=useState(null);

    const getData = async() => {
        try {
            const response = await Api({
                method:"get",
                url:`/audits/my_audits/archived`,
                headers:{} 
            })
            setBlock(true);
            setData(response.data)
        } catch (error) {
            // setErrorInfo(`Ошибка при получении данных об архивных аудитах.`);
            setErrorInfo(error);
            setError(true);
        }
    }
    
    useEffect(()=>{
        const setUp = async() => {
            setLoading(true);
            await getData();
            setLoading(false)
        };
        setUp();
    },[])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<p className="warning_text">{errorInfo}</p>)}
    if(block){return(<ArchiveAuditsInterface data={data}/>)}

}

const ArchiveAuditsBlock = () => {
    return(<ArchiveAuditFetch/>)
}

export default ArchiveAuditsBlock;